import { ToolBarStandardButton, ToolBarStandardButtonType } from "./toolBar.js";
import { Grid } from "./grid.js";
import { Helper } from "../util/helper.js";
import { General } from "../../../siteManagement/general.js";
import { NotificationHelper } from "../util/notificationHelper.js";
import { HTTPService, JsonResultClass } from "../util/httpManager.js";
import { DocumentListItem } from "../../documents/documents.js";
import { Context } from "./commonApp.js";
import { StringKeyDictionary } from "../../commonInterfaces.js";
import React from "react";

export default class Logs extends React.Component<LogsProps, any>{
    private _dataLoaded = false;
    private _icuh = Helper;
    private _translations: StringKeyDictionary<string>;
    private _gridData = [];
    private _gridOptions = {};
    private _menuElement: HTMLElement = null;

    constructor(props) {
        super(props)
        this._initApp();
    }


    private _getGridData() {
        const dataUrl = 'Log/GetLogs?table=' + this.props.tableName + '&index1=' + encodeURIComponent(this.props.context.keyVal1)
            + (this._icuh.hasValue(this.props.context.keyVal2) ? '&index2=' + encodeURIComponent(this.props.context.keyVal2) : "")
            //+ (this._icuh.hasValue(this.props.context.keyVal3) ? '&index3=' + encodeURIComponent(this.props.context.keyVal3) : "")
            ;
        return new Promise<JsonResultClass>((resolve, reject) => {
            HTTPService.get<JsonResultClass>(dataUrl)
                .then(result => {
                    if (result.Code === 0) {
                        this._gridData = result.Data;
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }

                    this.setState({}, () => {
                        resolve(result);
                    });
                });
        });
    }


    handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: any) => {
        if (type === ToolBarStandardButtonType.RELOAD) {
            this._getGridData();
        }
    }

    onSelectionChanged = (dataItem) => {
        if (this._icuh.hasValue(dataItem)) {
            let item = dataItem;
            let baseText = difflib.stringAsLines(item.Altwert === null ? "" : item.Altwert);
            let newText = difflib.stringAsLines(item.Neuwert === null ? "" : item.Neuwert);

            let sm = new difflib.SequenceMatcher(baseText, newText);
            let opcodes = sm.get_opcodes();

            const sheet = General.Sheet.Manager.createSheet();
            sheet.setTitle(this._translations["WebSMS.Log.Differenz"]);
            sheet.show(() => {
                sheet.appendStringContent(diffview.buildView({
                    baseTextLines: baseText,
                    newTextLines: newText,
                    opcodes: opcodes,
                    baseTextName: this._translations["WebSMS.Log.Altwert"],
                    newTextName: this._translations["WebSMS.Log.Neuwert"],
                    contextSize: null,
                    viewType: 0
                }));
            });
        }
    }

    private _initApp = () => {
        Promise.all([
            this._getGridData(),
            Helper.getTranslations(["WebSMS.Log.Spaltenname", "WebSMS.Log.Altwert", "WebSMS.Log.Neuwert",
                "WebSMS.Log.Wer", "WebSMS.Log.Wann", "WebSMS.Log.Art", "WebSMS.Log.Zusatz", "WebSMS.Log.Id",
                "WebSMS.Log.Index1", "WebSMS.Log.Index2", "WebSMS.Log.Index3", "WebSMS.Log.Tabname",
                "MonitorBaum.NeuLaden", "WebSMS.Log.Differenz", "Standard.CloseBtn"])
        ])
            .then(result => {
                this._translations = result[1].Data;
                this._gridOptions = {
                    dataSource: {
                        //data: [],
                        schema: {
                            model: {
                                fields: {
                                    Wann: { type: "date" }
                                }
                            }
                        },
                    },
                    sortable: true,
                    pageable: true,
                    groupable: true,
                    filterable: true,
                    selectable: true,
                    resizable: true,
                    columns: [
                        {
                            field: "Wann",
                            title: this._translations["WebSMS.Log.Wann"],
                            template: "#= kendo.toString(kendo.parseDate(Wann), 'G') #",
                            width: 80
                        },
                        {
                            field: "TranslationColumn",
                            title: this._translations["WebSMS.Log.Spaltenname"],
                            width: 80
                        },
                        {
                            field: "Altwert",
                            title: this._translations["WebSMS.Log.Altwert"],
                            template: "#= (data.AltwertTranslated == null) ? (data.Altwert == null ? '' : data.Altwert) : data.AltwertTranslated #",
                            width: 120
                        },
                        {
                            field: "Neuwert",
                            title: this._translations["WebSMS.Log.Neuwert"],
                            template: "#= (data.NeuwertTranslated == null) ? (data.Neuwert == null ? '' : data.Neuwert) : data.NeuwertTranslated #",
                            width: 120
                        },
                        {
                            field: "Wer",
                            title: this._translations["WebSMS.Log.Wer"],
                            width: 80
                        },
                        {
                            field: "MobileTemplate",
                            template: this.mobileTemplate
                        }
                    ]
                };

                this._dataLoaded = true;
                this.setState({});
            });
    }

    private mobileTemplate = (item: DocumentListItem) => {
        let template = kendo.template(`<div class='list-item'>
            <div class='list-item__title'>#: TranslationColumn#</div>
            <div class='list-item__row'>
                #if(data.Altwert){#
                    <div class='list-item__text list-item__text--small list-item__text--old'>#: Altwert ?? ''#</div>
                #}#
                #if(data.Altwert && data.Neuwert){#
                    <i class='fal fa-arrow-right'></i>
              	#}#
                <div class='list-item__text list-item__text--small list-item__text--new'>#: Neuwert ?? ''#</div>
            </div>
            <div class='list-item__row'>
                <div>#: Wer ?? ''#</div>
                <div>#= kendo.toString(kendo.parseDate(Wann), 'G') #</div>
            </div>
        </div>`);

        return template(item);
    }

    render() {
        let content = null;
        if (this._dataLoaded) {
            const standardButtons: Array<ToolBarStandardButton> = [];
            standardButtons.push({ type: ToolBarStandardButtonType.RELOAD, caption: this._translations["MonitorBaum.NeuLaden"], enabled: true });
            content = <Grid data={this._gridData} options={this._gridOptions} id="logs"
                standardButtons={standardButtons} onClickStandardButton={this.handleClickStandardButton} onSelectionChanged={this.onSelectionChanged}
                useFloatingButtons={true}
            />
        }

        return (content);
    }
}

interface LogsProps {
    tableName: string;
    context: Context;
}